import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';
import { useViewAs } from '@/hooks/useViewAs';

export function useRole() {
  const { user } = useAuth();
  const { viewAs } = useViewAs();

  const { data: roles = [], isLoading } = useQuery({
    queryKey: ['user-roles', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user!.id);
      if (error) throw error;
      return data.map((r: any) => r.role as string);
    },
    enabled: !!user,
  });

  const realIsAdmin = roles.includes('admin');

  // Admin-only "View as" preview. Only affects the UI this admin sees.
  const effectiveRoles =
    realIsAdmin && viewAs
      ? viewAs === 'dealer'
        ? []
        : [viewAs]
      : roles;

  const isAdmin = effectiveRoles.includes('admin');
  const isAccountManager = effectiveRoles.includes('account_manager');
  const isRep = effectiveRoles.includes('rep');

  return {
    roles: effectiveRoles,
    isAdmin,
    isAccountManager,
    isRep,
    realIsAdmin,
    viewAs: realIsAdmin ? viewAs : null,
    // Dealer = no elevated role. Default to dealer when roles haven't loaded yet.
    isDealer: (!isAdmin && !isAccountManager && !isRep) || effectiveRoles.length === 0,
    isLoading,
  };
}
